export default {
	rounded: {
		borderRadius: 12
	},
	elevation1: {
		boxShadow: "none",
	}
}
